import * as actionCreators from '../state/actionCreators'
import { DeliveriesState } from "../state/reducer"
import { useSelector } from "react-redux"
import { State } from "../../../state"
import { bindActionCreators } from "redux"
import { useDispatch } from "react-redux"

export const useDeliveriesState = (): DeliveriesState => useSelector((state: State) => state.deliveriesReducer)

export const useDeliveriesStateActions = () => bindActionCreators(actionCreators, useDispatch())
